import { INavMenuItem } from './nav-menu-item.interface';
import { getAnnualStatementsPath } from "../../../shared/utils/route-path-utils";

export const annualStatementsMenuItems: INavMenuItem[] = [
  {
    routerLink: getAnnualStatementsPath('ready-to-send'),
    icon: '',
    title: 'Ready to Send',
    count: 0,
  },
  {
    routerLink: getAnnualStatementsPath('not-received'),
    icon: '',
    title: 'Not Received',
    count: 0,
  },
  {
    routerLink: getAnnualStatementsPath('expected'),
    icon: '',
    title: 'Expected',
    count: 0,
  },
  {
    routerLink: getAnnualStatementsPath('sent'),
    icon: '',
    title: 'Sent',
    count: 0
  },
  {
    routerLink: getAnnualStatementsPath('payment-due'),
    icon: '',
    title: 'Payment Due',
    count: 0
  },
  {
    routerLink: getAnnualStatementsPath('overdue'),
    icon: '',
    title: 'Overdue',
    count: 0
  },
  {
    routerLink: getAnnualStatementsPath('archived'),
    icon: '',
    title: 'Archived',
    count: 0
  },
  {
    routerLink: getAnnualStatementsPath('all'),
    icon: '',
    title: 'All',
    count: 0
  },
]

export const menuItemsList: INavMenuItem[] = [
  {
    routerLink: ['companies'],
    icon: 'ic-companies-20',
    title: 'Companies'
  },
  {
    routerLink: ['trusts'],
    icon: 'ic-trusts-20',
    title: 'Trusts',
    hideProd: true,
  },
  {
    routerLink: ['individuals'],
    icon: 'ic-individuals-20',
    title: 'Individuals'
  },
  {
    routerLink: ['documents'],
    icon: 'ic-documents-20',
    title: 'Documents'
  },
  {
    routerLink: ['alerts'],
    icon: 'ic-alert-triangle-20',
    title: 'Alerts',
    count: 0,
    nestedItems: [
      {
        routerLink: ['alerts/inbox'],
        icon: '',
        title: 'Inbox',
        count: 0,
      },
      {
        routerLink: ['alerts/all'],
        icon: '',
        title: 'All',
        count: 0,
      },
      {
        routerLink: ['alerts/required'],
        icon: '',
        title: 'Require Attention',
        count: 0,
      },
      {
        routerLink: ['alerts/postponed'],
        icon: '',
        title: 'Postponed',
        count: 0
      },
    ]
  },
  {
    routerLink: ['outgoing-messages'],
    icon: 'ic-outgoing-emails-20',
    title: 'Outgoing Messages',
    nestedItems: [
      {
        title: 'Emails',
        routerLink: ['outgoing-messages', 'email'],
      },
      {
        title: 'SMS',
        routerLink: ['outgoing-messages', 'sms'],
      },
    ]
  },
  {
    routerLink: ['annual-statements'],
    icon: 'ic-annual-statement-20',
    title: 'Annual Statements',
    count: 0,
    nestedItems: annualStatementsMenuItems
  },
  {
    routerLink: ['bulk-changes'],
    icon: 'ic-bulk-changes-20',
    title: 'Bulk Changes',
  },
  {
    routerLink: ['settings'],
    icon: 'ic-settings-20',
    title: 'Settings',
  }
];

export const sauperUserMenuItems: INavMenuItem[] = [
  {
    routerLink: ['superuser/me'],
    icon: 'fa-address-card fad',
    title: 'Me'
  },
  {
    routerLink: ['superuser/edge-transactions'],
    icon: 'ic-inbox-20',
    title: 'Edge Transactions'
  }
];
